import { getLocalStorage } from "./useLocalStorage";

export function getAuthData() {
    const token = getLocalStorage("token", false);
    const dataname = getLocalStorage("dbname", false);
    return { token, dataname };
}
